export default __webpack_public_path__ + "static/banner.alupress-2a65d78bc80b46fb2785d6144e16f6bc.png";